import { render, staticRenderFns } from "./webIndex1.vue?vue&type=template&id=52d4b212&scoped=true"
import script from "./webIndex1.vue?vue&type=script&lang=js"
export * from "./webIndex1.vue?vue&type=script&lang=js"
import style0 from "./webIndex1.vue?vue&type=style&index=0&id=52d4b212&prod&scoped=true&lang=css"
import style1 from "./webIndex1.vue?vue&type=style&index=1&id=52d4b212&prod&scoped=true&lang=css"
import style2 from "./webIndex1.vue?vue&type=style&index=2&id=52d4b212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d4b212",
  null
  
)

export default component.exports